<template>
  <v-app>
    <v-container>
        <v-row>
            
        </v-row>
        <v-row>
            <v-col cols="12" sm="3" md="3">
                <v-card>
                    <v-card-title>No. de solicitudes</v-card-title>
                    <v-card-text>
                        <h5>{{total_solicitudes}}</h5>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" sm="3" md="3">
                <v-card>
                    <v-card-title>Total Aprobado</v-card-title>
                    <v-card-text>
                        <h5>{{total_aprobado}}</h5>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" sm="3" md="3">
                <v-card>
                    <v-card-title>Total Rechazado</v-card-title>
                    <v-card-text>
                        <h5>{{total_rechazado}}</h5>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" sm="3" md="3">
                <v-card>
                    <v-card-title>Total Pendiente</v-card-title>
                    <v-card-text>
                        <h5>{{total_pendiente}}</h5>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="6" md="6"><GChart class="mt-5" type="ColumnChart" :data="chartData" :options="chartOptions" height="500px" /></v-col>
            <v-col cols="12" sm="6" md="6"><GChart class="mt-5" type="ColumnChart" :data="chartData_trimestre" :options="options_columna" height="500px" /></v-col>
        </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { GChart } from 'vue-google-charts'
import axios from 'axios'
import router from '../router/index.js'

export default {
    components: {
        GChart
    },
    data(){
        return {
            chartData: [['Concepto', 'Importe']],
            chartData_trimestre: [['Concepto', 'Importe']],
            chartOptions: {title: 'Gastos anuales', is3D: false,height: 500,colors: ['green'],},
            datos_columna: [],
            options_columna: { title: 'Gastos del actual trimestre',is3D: true,height: 500},
            gastos: [],
            total_solicitudes: null,
            total_aprobado: null,
            total_rechazado: null,
            total_pendiente: null
        }
    },
    methods: {
        get_gastos_anuales: async function(){
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/totales/anio").then( res => { 
                res.data.forEach(element => {
                    var tmp = [element['cuenta'], parseInt(element['total'])];
                    this.chartData.push(tmp);
                });
            } );
        },
        dynamicColors: function() {
            var r = Math.floor(Math.random() * 255);
            var g = Math.floor(Math.random() * 255);
            var b = Math.floor(Math.random() * 255);
            return "rgba(" + r + "," + g + "," + b + ",0.2)";
        },
        get_gastos_trimestrales: async function(){
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/totales/trimestre").then( res => { 
                res.data.forEach(element => {
                    var tmp = [element['cuenta'], parseInt(element['total'])];
                    this.chartData_trimestre.push(tmp);   
                });
            } );
        },
        get_data_dashboard: async function(){
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/dashboard/resumen/").then(function(){} );
        },
        get_data_cards: async function(){
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/dashboard/resumen/cards").then( res => { 
                this.total_solicitudes = res.data[0]['total_solicitudes'];
                this.total_rechazado = res.data[0]['total_rechazado'];
                this.total_aprobado = res.data[0]['total_aprobado'];
                this.total_pendiente = res.data[0]['total_pendiente'];
            });
        }
    },
    created: function(){
        this.get_gastos_anuales();
        this.get_gastos_trimestrales();
        this.get_data_cards();
    },
    mounted() {
        //Config for axios
        axios.defaults.headers.common['access-token'] = this.$store.state.token;
        axios.interceptors.response.use(function (response){
            if (response.data.message == 'Token inválida') {
                router.push({name: 'login', params: {errorToken: 'true'}});
            }else{
                return response;
            }
        });
        //End config for axios
    }
}
</script>

<style>


</style>